import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionButton from '../Common/ActionButton';
import Modal from '../Common/Modal';

interface Language {
  code: string;
  name: string;
  flag: string;
}

const languages: Language[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' }
];

interface LanguageSelectionModalProps {
  isOpen: boolean;
  onLanguageSelect: (languageCode: string) => void;
}

const LanguageSelectionModal: React.FC<LanguageSelectionModalProps> = ({ 
  isOpen, 
  onLanguageSelect 
}) => {
  const { t } = useTranslation();
  return (
    <Modal 
      isOpen={isOpen} 
      onClose={() => {}} 
      title={t('language.selectLanguage')}
      showCloseButton={false}
      contentClassName="bg-gradient-to-br from-blue-50 to-purple-50"
    >
      <div className="space-y-4">
        {languages.map((language) => (
          <ActionButton
            key={language.code}
            onClick={() => onLanguageSelect(language.code)}
            variant="secondary"
            size="lg"
            fullWidth={true}
          >
            <div className="flex items-center justify-center gap-3">
              <span className="text-2xl">{language.flag}</span>
              <span className="text-lg font-semibold">{language.name}</span>
            </div>
          </ActionButton>
        ))}
      </div>
    </Modal>
  );
};

export default LanguageSelectionModal;